export default {
  s: '%d วินาที',
  smicro: '%d วิ',
  smid: '%d วิ',

  ss: '%d วินาที',
  ssmicro: '%d วิ',
  ssmid: '%d วิ',

  m: '%d นาที',
  mmicro: '%d น',
  mmid: '%d น',

  mm: '%d นาที',
  mmmicro: '%d น',
  mmmid: '%d น',

  h: '%d ชั่วโมง',
  hmicro: '%d ชม',
  hmid: '%d ชั่วโมง',

  hh: '%d ชั่วโมง',
  hhmicro: '%d ชม',
  hhmid: '%d ชั่วโมง',

  d: '%d วัน',
  dmicro: '%d ว',
  dmid: '%d วัน',

  dd: '%d วัน',
  ddmicro: '%d ว',
  ddmid: '%d วัน',
};
